(function () {
  function bindChargeCompare(root) {
    if (!root || root.dataset.ready === 'true') return;
    root.dataset.ready = 'true';

    const target = root.querySelector('[data-l20-charge-bars]') || root;
    const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    if (reduceMotion) {
      root.classList.add('is-animated');
      return;
    }

    const observer = new IntersectionObserver(function (entries) {
      const visible = entries.some(function (entry) {
        return entry.isIntersecting && entry.intersectionRatio > 0;
      });

      if (visible) {
        if (root.classList.contains('is-animated')) return;
        root.classList.remove('is-animated');
        void root.offsetWidth;
        root.classList.add('is-animated');
        return;
      }

      root.classList.remove('is-animated');
    }, {
      threshold: [0, 0.2, 0.35],
      rootMargin: '0px 0px -18% 0px'
    });

    observer.observe(target);
  }

  class L20ChargeCompare extends HTMLElement {
    connectedCallback() {
      bindChargeCompare(this);
    }
  }

  window.initL20ChargeCompare = bindChargeCompare;

  if (!customElements.get('l20-charge-compare')) {
    customElements.define('l20-charge-compare', L20ChargeCompare);
  }

  document.addEventListener('shopify:section:load', function (event) {
    const root = event.target.querySelector('l20-charge-compare');
    if (!root) return;
    root.dataset.ready = '';
    bindChargeCompare(root);
  });
})();
